module.exports = __webpack_public_path__ + "img/logo.5834bbb9.png";